/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
import EVENTS from '../../../../constants/artifacts_events.constants';
import API from '../../../../constants/api.constants';
import TOOLTIP from '../../../../constants/artifact_tooltip.constant';

export class ArtifactoryAdminConfigurationGeneralController {

    constructor($scope, $q, $timeout, $stateParams, FileUploader, JFrogNotifications, GeneralConfigDao, FooterDao, JFrogEventBus, ArtifactoryModelSaver, ArtifactActionsDao, JFrogModal, ArtifactoryFeatures) {
        this.$scope = $scope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.artifactoryNotifications = JFrogNotifications;
        this.JFrogEventBus = JFrogEventBus;
        this.artifactActionsDao = ArtifactActionsDao;
        this.generalConfigDao = GeneralConfigDao;
        this.footerDao = FooterDao;
        this.FileUploader = FileUploader;
        this.modal = JFrogModal;
        this.TOOLTIP = TOOLTIP.admin.configuration.general;
        this.ArtifactoryModelSaver = ArtifactoryModelSaver.createInstance(this, ['generalConfigData']);
        this.features = ArtifactoryFeatures;

        this._getGeneralConfigData();
    }
    customMessageToggle() {
        this.toggleColorPicker();
    }
    toggleColorPicker() {
        $('.color-picker-input').prop('disabled', !this.generalConfigData.systemMessageEnabled);
    }
    _getGeneralConfigData() {
        this.generalConfigDao.get().$promise.then((data) => {
            this.generalConfigData = data;
            this.blockReplications = data.blockPushReplications || data.blockPullReplications;
            this.generalConfigData.systemMessageTitleColor = this.generalConfigData.systemMessageTitleColor.toUpperCase();
        this.ArtifactoryModelSaver.save();
            if (this.generalConfigData.systemMessageEnabled == false) {
                this.toggleColorPicker();
            }
        });
    }

    _updateGeneralConfigData() {
        this.generalConfigDao.update(this.generalConfigData).$promise.then((data) => {
            this.ArtifactoryModelSaver.save();
        this.JFrogEventBus.dispatch(EVENTS.FOOTER_DATA_UPDATED);
        });
    }

    save() {
        this._updateGeneralConfigData();
    }

    cancel() {
        this.ArtifactoryModelSaver.ask(true).then(() => {
            this._getGeneralConfigData();
        });
    }

    emptyTrashcan() {
        this.modal.confirm('Are you sure you want to empty the trash can?', 'Empty Trash',
            {confirm: 'Empty Trash'})
            .then(() => this.artifactActionsDao.perform({action: 'emptytrash'}, {}));
    }

    onChangeBlockReplications() {
        this.generalConfigData.blockPushReplications = this.blockReplications;
        this.generalConfigData.blockPullReplications = this.blockReplications;
    }

    onChangePushPullReplications() {
        this.blockReplications = this.generalConfigData.blockPushReplications || this.generalConfigData.blockPullReplications;
    }

    onChangeFolderDownload() {
        this.generalConfigData.folderDownloadEnabledForAnonymous = false;
    }
}



// WEBPACK FOOTER //
// ./states/admin/configuration/artifactoryGeneral/artifactoryGeneral.controller.js